if (!customElements.get('c2f-media-gallery')) {
  customElements.define('c2f-media-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-gallery-media]')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-target]')];
      this.stage = this.querySelector('.c2f-media-gallery__stage');
      this.index = Math.max(0, this.panels.findIndex(panel => !panel.hidden));
      this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.galleryStep)), options));
      this.thumbs.forEach(button => button.addEventListener('click', () => this.setActiveMedia(button.dataset.galleryTarget), options));
      this.querySelector('[data-gallery-zoom]').addEventListener('click', () => this.panels[this.index]?.querySelector('modal-opener button')?.click(), options);
      this.stage.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('video,iframe,model-viewer,deferred-media,product-model')) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.stage.addEventListener('touchstart', event => {
        if (event.target.closest('video,iframe,model-viewer,deferred-media,product-model')) return;
        const point = event.changedTouches[0];
        this.touch = { x: point.clientX, y: point.clientY };
      }, { ...options, passive: true });
      this.stage.addEventListener('touchend', event => {
        if (!this.touch) return;
        const point = event.changedTouches[0], dx = point.clientX - this.touch.x, dy = point.clientY - this.touch.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(dx < 0 ? 1 : -1);
        this.touch = null;
      }, { ...options, passive: true });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    move(step) {
      if (!this.panels.length) return;
      this.setActiveMedia(this.panels[(this.index + step + this.panels.length) % this.panels.length].dataset.galleryMedia);
    }
    setActiveMedia(mediaId) {
      if (!this.panels) return;
      const next = this.panels.findIndex(panel => panel.dataset.galleryMedia === mediaId);
      if (next < 0) return;
      if (next !== this.index) window.pauseAllMedia?.();
      this.index = next;
      this.update();
    }
    update() {
      this.panels.forEach((panel, index) => { panel.hidden = index !== this.index; panel.inert = index !== this.index; });
      this.thumbs.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.index)));
      this.querySelector('[data-gallery-counter]').textContent = `${this.index + 1} / ${this.panels.length}`;
      this.querySelector('[data-gallery-zoom]').hidden = this.panels[this.index]?.dataset.mediaType !== 'image';
      const thumb = this.thumbs[this.index], rail = this.querySelector('.c2f-media-gallery__thumbs');
      if (thumb && rail) {
        const item = thumb.getBoundingClientRect(), frame = rail.getBoundingClientRect();
        if (item.left < frame.left || item.right > frame.right) rail.scrollLeft += item.left - frame.left - (frame.width - item.width) / 2;
      }
    }
  });
}
